<template>
  <div class="calendar-container">
    <div v-if="showCalendarsList">
        <div v-for="c in calendars" :key="c.id" class="calendar-selector btn" :class="[selectedCalendars.includes(c.id) ? 'btn-primary': 'btn-secondary']">
            <input type="checkbox" :value="c.id" :id="`select-calendar-${c.id}`" v-model="selectedCalendars"/>
            <label :for="`select-calendar-${c.id}`">{{ c.name }}</label>
            <span @click="openEventEditor(c.id)">
                <i class="fas fa-plus-circle"></i>
            </span>
        </div>
    </div>
    <EventEditor v-model="newEvent" v-if="currentCalendar" :calendar="currentCalendar" @v-on:success="closeEventEditor()"></EventEditor>
    <VueCal
      :events="events"
      :locale="$store.getters.currentLangCode"
      :disableViews="['years', 'year']"
      :dblClickToNavigate="false"
      :hideWeekends="false"
      :timeFrom="6*60"
      :timeTo="22*60"
      :timeCellHeight="90"
      :eventsOnMonthView="true"
      :noEventOverlaps="true"
      :onEventDblclick="onEventDblClick"
      :defaultView="defaultView"
      todayButton
    >
    </VueCal>

  </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import _ from 'lodash'
import { dateObjectFromInput } from 'CORE/utils/date'
import moment from 'moment'
import EventEditor from './event-editor'
import { RRule } from 'rrule';

const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD HH:mm'

export default {
    name: 'Calendar',
    components: {
        VueCal,
        EventEditor,
    },
    props: {
        rootFilterFunctions: {
            type: Function,
        },
        defaultView: {
            type: String,
            default: 'week',
        },
        showCalendarsList: {
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            selectedCalendars: [],
            newEvent: {},
            currentCalendarId: undefined,
        }
    },
    computed: {
        calendars() {
            return this.$store.getters.calendars
        },
        calendarEvents() {
            return this.$store.getters.events
        },
        currentCalendar() {
            return this.$store.getters.getCalendarById(this.currentCalendarId)
        },
        taskObjects() {
            let tasks = this.$store.getters.tasks
            // pridame k property values jejich tagy aby bylo lehci filtrovat
            tasks = _.map(tasks, o => {
                o.propertyValues = _.mapValues(o.propertyValues, (pv, k) => {
                    const property = this.$store.getters.propertyTypeByKey(k)
                    const systags = _.keys(_.get(property, 'settings.systags', {}))
                    return _.set(pv, 'systags', systags)
                })
                o.systags = {}
                o.systagsValues = {}
                // udela to prehlednejsi strukturu dat pro filtrovani
                // systagy podle klice a hodnoty
                _.each(o.propertyValues, (v, k) => {
                    _.mapKeys(v.systags, k2 => {
                        _.set(o.systags, k2, k)
                        _.set(o.systagsValues, k2, v.value)
                    })
                })
                return o
            })
            // odfiltrujeme vsechny tasky ze kterych nejde udelat kalendar
            // zaroven pro ne vyrobime _calendarEntry podle ktere se lze dal ridit
            tasks = _.filter(tasks, o => {
                const starttime = _.get(o, `systagsValues.starttime`, false)
                const duration = _.get(o, `systagsValues.duration`, false)
                if (starttime && duration) {
                    o._calendarEntry = {
                        start: moment(starttime).format(CALENDAR_DATE_FORMAT),
                        end: moment(starttime).add(duration, 'seconds').format(CALENDAR_DATE_FORMAT),
                    }
                    return true
                }
                return false
            })
            if (_.isFunction(this.rootFilterFunctions)) {
                tasks = _.filter(tasks, this.rootFilterFunctions)
            } else {
                console.warn('rootFilterFunctions not defined')
            }
            return tasks
        },
        newEvents() {
            if(_.get(this.newEvent, 'startDate', false) && _.size(this.newEvent.rrule)) {
                const start = moment(_.get(this.newEvent, 'startDate', false)).subtract(2, 'day').utc().toDate()
                const end = moment(start).add(1, 'year').utc().toDate()
                const rule = RRule.fromString(this.newEvent.rrule)
                const newEvents = rule.between(start, end).map(startDate => {
                    return {
                        title: `Nová událost ${this.newEvent.name}`,
                        start: moment(startDate).format(CALENDAR_DATE_FORMAT),
                        end: moment(startDate).add(this.newEvent.length, 'seconds').format(CALENDAR_DATE_FORMAT),
                        class: 'newEvent',
                    }
                })
                return newEvents
            } else if(_.get(this.newEvent, 'startDate', false)) {
                const start = moment(_.get(this.newEvent, 'startDate', false)).utc().toDate()
                return [{
                    title: `Nová událost ${this.newEvent.name}`,
                    start: moment(start).format(CALENDAR_DATE_FORMAT),
                    end: moment(start).add(this.newEvent.length, 'seconds').format(CALENDAR_DATE_FORMAT),
                    class: 'newEvent',
                }]
            } else {
                return []
            }
        },
        events() {
            try {
                let events = []

                const generatedEvents = _.map(this.taskObjects, o => {
                    const resourceId = _.get(o, 'propertyValues.system-person.value.value')
                    _.set(o._calendarEntry, 'taskId', _.get(o, 'id'))
                    _.set(o._calendarEntry, 'title', _.get(o, 'propertyValues.system-name.value.value'))
                    _.set(o._calendarEntry, 'content',
                        '<i class="fas fa-user"></i> ' +
                    _.get(this.$store.getters.resourceById(resourceId), 'propertyValues.system-jmeno.value.value', 'Nezadáno') + ' ' +
                    _.get(this.$store.getters.resourceById(resourceId), 'propertyValues.system-prijmeni.value.value', ''))
                    _.set(o._calendarEntry, 'class', _.get(this.$store.getters.getProjectById(o.project.id), 'propertyValues.system-color.value.value', 'default'))
                    return o._calendarEntry
                })

                events = _.union(events, generatedEvents)

                const calendarEvents = _.map(_.filter(this.calendarEvents, ce => this.selectedCalendars.includes(ce.calendar.id)),ce => {
                    let taskID = _.get(ce, 'task.id', null)
                    let task = taskID !== null ? this.$store.getters.taskById(ce.task.id) : null
                    let calendar = this.$store.getters.getCalendarById(ce.calendar.id)
                    if (ce.rrule !== null) {
                        const start = moment(_.get(ce, 'start', false)*1000).subtract(2, 'day').utc().toDate()
                        const end = moment(start).add(1, 'year').utc().toDate()
                        const rule = RRule.fromString(ce.rrule)
                        events = _.union(events, rule.between(start, end).map(startD => {
                            return {
                                taskId: null,
                                title: ce.title,
                                start: moment(startD, 'X').format(CALENDAR_DATE_FORMAT),
                                end: moment(startD, 'X').add(ce.duration, 'seconds').format(CALENDAR_DATE_FORMAT),
                                class: 'andere',
                                content: '<i class="fas fa-user"></i> ' + _.get(calendar, 'name'),
                            }
                        }))
                    } else {
                        return {
                            taskId: taskID,
                            title: ce.title,
                            start: moment(ce.start, 'X').format(CALENDAR_DATE_FORMAT),
                            end: moment(ce.start, 'X').add(ce.duration, 'seconds').format(CALENDAR_DATE_FORMAT),
                            class: task === null ? 'default' : _.get(this.$store.getters.getProjectById(task.project.id), 'propertyValues.system-color.value.value', 'default'),
                            content: '<i class="fas fa-user"></i> ' + _.get(calendar, 'name'),
                        }
                    }
                })
                events = _.union(events, calendarEvents)
                events = _.union(events, this.newEvents)

                return events
            } catch (e) {
                console.error(e)
                return []
            }
        },
    },
    methods: {
        onEventDblClick(event, e) {
            this.$router.push('/tasks/detail/' + event.taskId)
            // Prevent navigating to narrower view (default vue-cal behavior).
            e.stopPropagation()
        },
        openEventEditor(id) {
            this.currentCalendarId = id
        },
        closeEventEditor() {
            this.currentCalendarId = undefined
        }
    },
}
</script>

<style>
.vuecal__event {
  color: black;
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.51);
  -moz-box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.51);
  box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.51);
}
.vuecal__event-title {
  padding-top: 5px;
  font-weight: bold;
}
.vuecal__event.default {
  background-color: #80cbc4;
}
.vuecal__event.danube {
  background-color: #42a5f5;
}
.vuecal__event.blueMarquerite {
  background-color: #6d61c1;
}
.vuecal__event.fuchsiaPink {
  background-color: #ab47bc;
}
.vuecal__event.cranberry {
  background-color: #ec407a;
}
.vuecal__event.coralRed {
  background-color: #ef5350;
}
.vuecal__event.pictonBlue {
  background-color: #29b6f6;
}
.vuecal__event.scooter {
  background-color: #26c6da;
}
.vuecal__event.persianGreen {
  background-color: #159f92;
}
.vuecal__event.fern {
  background-color: #66bb6a;
}
.vuecal__event.atlantis {
  background-color: #9ccc64;
}
.vuecal__event.candyCorn {
  background-color: #ffee58;
}
.vuecal__event.sunglow {
  background-color: #fdcb2e;
}
.vuecal__event.webOrange {
  background-color: #fca826;
}
.vuecal__event.burningOrange {
  background-color: #ff7043;
}
.calendar-selector > label {
    margin: 0 0 0 6px;
}
.vuecal__event.newEvent {
    background: repeating-linear-gradient(135deg, rgba(0,0,0,0.2) 0,rgba(0,0,0,0.2) 10px,rgba(255,212,0,0.2) 11px, rgba(255,212,0,0.2) 20px);
    border: 2px dashed dimgray;
}
</style>
